import { Box, useTheme, CssBaseline, useMediaQuery } from "@mui/material";
import { HeaderIsPlanExpired } from "src/Pages/components/HeaderIsPlanExpired/HeaderIsPlanExpired";

import { CardMain } from "./Drawers/Components/CardMain";
import { DrawerDesktop } from "./Drawers/DrawerDesktop";
import { DrawerMobile } from "./Drawers/DrawerMobile";
import { useAppThemeContext } from "src/Contexts/ThemeContextConfig";
import { Outlet } from "react-router-dom";
import { ModalSubscriptions } from "src/Pages/TelasSistemas/Plans/Components/ModalSubscription/ModalSubscriptions";
import { useAuthContext } from "src/Contexts/AuthContext/authContext";

export const MasterLayout = () => {
  const theme = useTheme();
  const { authorization, userPerfil } = useAuthContext();
  const { themeName } = useAppThemeContext();

  const matches = useMediaQuery(theme.breakpoints.up("md"));

  return (
    <Box sx={{ position: "relative" }}>
      <CssBaseline />
      {authorization && userPerfil && <ModalSubscriptions />}
      <Box
        sx={{
          minHeight: "100vh",
          background: (theme) =>
            themeName === "light" ? "#f8f8f8" : theme.palette.background.paper,
        }}
      >
        {!matches ? <DrawerMobile /> : <DrawerDesktop />}

        <CardMain>
          <Outlet />
        </CardMain>
      </Box>

      <Box sx={{ zIndex: 999, position: "fixed", bottom: 0, width: "100%" }}>
        <HeaderIsPlanExpired />
      </Box>
    </Box>
  );
};
